import { Container, Row, Col, Button, Card } from "react-bootstrap"
import droneImage from "../Images/drone.jpg"
import cyberRisk from "../Images/cyberrisk.jpg"
import RianBotes from "../Images/rianbotes.png"
import ReactGA from "react-ga4";

import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const SpecialRisks = () => {
    ReactGA.initialize("G-ECGH6LJ63Y");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    return (
        <>   <Container
            fluid
            style={{
                background: 'linear-gradient(135deg, #1e1e3f 0%, #3a275e 50%, #ffcc00 100%)',
                color: '#ffffff',
                padding: '4rem 2rem',
                position: 'relative',
                textAlign: 'center',
                overflow: 'hidden',
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 1,
                }}
            />
            <div style={{ position: 'relative', zIndex: 2 }}>
                <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '1rem' }}>
                    Special Risks
                </h1>
                <p style={{ fontSize: '1.25rem', maxWidth: '700px', margin: '0 auto', color: '#f0f0f0' }}>
                    Drones, Events, Cyber, Engineering
                </p>
            </div>
        </Container>
            <br />
            <Container>
                {/* Drone Insurance Section */}
                <Row
                    style={{
                        backgroundColor: '#ffffff',
                        padding: '2.5rem',
                        borderRadius: '20px',
                        boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.1)',
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        display: 'flex',
                        alignItems: 'stretch',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0px 6px 24px rgba(0, 0, 0, 0.1)';
                    }}
                    className="mb-5"
                >
                    <Col xs={12} md={6} className="d-flex align-items-center justify-content-center">
                        <img
                            src={droneImage}
                            alt="Drone Insurance"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: '15px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                            }}
                        />
                    </Col>
                    <Col xs={12} md={6} className="d-flex flex-column justify-content-center">
                        <h2 style={{ fontSize: '2rem', color: '#1e1e3f' }}>Drone Insurance</h2>
                        <p style={{ fontSize: '1.1rem', color: '#333' }}>
                            The world as we know it is being changed by Drones. From a simple Toy to providing life saving Medicines in remote areas - or changing the way in which countries wage war against one another, Drones will be the subject of discussion around every campfire.
                            <br /><br />
                            The Industry is growing at a rapid pace and with it, regulations from Civil aviation more and more important. Insurance companies have been and continues to developing their policies to suit the needs of clients and assist them in managing their risk. It remains a combined effort.
                            <br /><br />
                            In this, Logos Brokers have been very much involved advising clients on how to cover their assets. Hull, Payload and the ever more important Liability cover. Make sure that you are insured by the right Insurer for your Drone operations.
                        </p>

                    </Col>
                </Row>

                {/* Cyber Crime Section */}
                <Row
                    style={{
                        backgroundColor: '#ffffff',
                        padding: '2.5rem',
                        borderRadius: '20px',
                        boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.1)',
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        display: 'flex',
                        alignItems: 'stretch',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0px 6px 24px rgba(0, 0, 0, 0.1)';
                    }}
                    className="mb-5"
                >
                    <Col xs={12} md={6} className="d-flex flex-column justify-content-center">
                        <h2 style={{ fontSize: '2rem', color: '#1e1e3f' }}>Cyber Crime</h2>
                        <p style={{ fontSize: '1.1rem', color: '#333' }}>
                            Cyber crime continues to headline in the media. It is the fasting growing crime activity and criminals are not limited by any international border. It is a global risk and no private home connected or Corporate institution is not exposed.
                            <br /><br />
                            The Cyber risk is not a problem addressed only by IT specialists but is in essence a managerial problem. Make sure that when the Fire Wall and Doors of your business gets tested, you will be assisted by a team of specialists as appointed and sourced by the Best Insurers whilst you are also compensated for losses in the process.
                        </p>

                    </Col>
                    <Col xs={12} md={6} className="d-flex align-items-center justify-content-center">
                        <img
                            src={cyberRisk}
                            alt="Cyber Crime"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: '15px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                            }}
                        />
                    </Col>
                </Row>
            </Container>
            <br />

            {/* Centered Broker Contact Card */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    //minHeight: '80vh', // Adjust as needed (e.g., 100vh for full screen)
                    padding: '2rem',
                    backgroundColor: '#f8f9fa', // Optional background for contrast
                }}
            >
                <Card
                    style={{
                        borderRadius: '15px',
                        boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.15)',
                        padding: '2rem',
                        textAlign: 'center',
                        maxWidth: '400px',
                        width: '100%',
                    }}
                >
                    <Card.Body>
                        <div
                            style={{
                                width: '100px',
                                height: '100px',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                margin: '0 auto',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            <img
                                src={RianBotes}
                                alt="Broker"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            />
                        </div>
                        <h3 style={{ fontSize: '1.5rem', margin: '1rem 0 0.5rem 0', fontWeight: '600' }}>Rian Botes</h3>
                        <p style={{ fontSize: '1rem', color: '#555' }}>Your personal guide for insurance solutions.</p>
                        <p style={{ fontSize: '1rem', color: '#007BFF' }}>
                            <FontAwesomeIcon icon={faPhone} /> 082 880 4219 <br />
                            <FontAwesomeIcon icon={faEnvelope} /> info@logosbrokers.co.za
                        </p>
                        <Button
                            variant="primary"
                            href="https://wa.me/828804219"
                            style={{ marginTop: '1rem' }}
                        >
                            Message on WhatsApp
                        </Button>
                    </Card.Body>
                </Card>
            </div>


        </>
    )
}
